import axiosInstance from "../../utils/axios";

const exportExcelAsset = async () => {
  try {
    return await axiosInstance.get(`/report/exportExcelAsset`, {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const exportExcelIncomeAndExpenses = async () => {
  try {
    return await axiosInstance.get(`/report/exportExcelIncomeAndExpenses`, {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const exportExcelInterest = async () => {
  try {
    return await axiosInstance.get(`/report/exportExcelInterest`, {
      responseType: "blob",
    });
  } catch (err) {
    console.error("Error fetching asset report:", err);
    throw err; // Propagate error to handle it in the calling function
  }
};

const ReportAPI = {
  exportExcelAsset,
  exportExcelIncomeAndExpenses,
  exportExcelInterest,
};

export default ReportAPI;
